
import styles from '../ProductInfo.module.css';

interface NamesInputProps {
    name1: string;
    setName1: (val: string) => void;
    name2: string;
    setName2: (val: string) => void;
    separator: string;
    setSeparator: (val: string) => void;
}

export const NamesInput = ({
    name1,
    setName1,
    name2,
    setName2,
    separator,
    setSeparator
}: NamesInputProps) => {
    return (
        <>
            <h4 className={styles.customizationTitle}>Composez votre projet Prénoms</h4>
            <div className={styles.initialsWrapper}>
                <input
                    type="text"
                    className={styles.initialInput}
                    style={{ width: '120px', textAlign: 'left', paddingLeft: '10px', textTransform: 'none' }}
                    placeholder="Prénom 1"
                    value={name1}
                    onChange={(e) => setName1(e.target.value)}
                />
                <div className={styles.separatorSelectWrapper}>
                    <select
                        className={styles.separatorSelect}
                        value={separator}
                        onChange={(e) => setSeparator(e.target.value)}
                    >
                        <option value="et">et</option>
                        <option value="&">&</option>
                        <option value="coeur">♡</option>
                        <option value="vide">Vide</option>
                    </select>
                </div>
                <input
                    type="text"
                    className={styles.initialInput}
                    style={{ width: '120px', textAlign: 'left', paddingLeft: '10px', textTransform: 'none' }}
                    placeholder="Prénom 2"
                    value={name2}
                    onChange={(e) => setName2(e.target.value)}
                />
            </div>
        </>
    );
};
